import { Checkbox } from 'antd'
import React from 'react'
import { CensusIngestionChannel } from '../../api/company-ignore-api-client'
import styles from './CompanyIgnore.module.scss'

const CHANNEL_OPTIONS: { label: string; value: CensusIngestionChannel }[] = [
  { label: 'AMA (HRIS integration)', value: CensusIngestionChannel.AMA },
  { label: 'API (integrations-S3 upload)', value: CensusIngestionChannel.API },
  {
    label: 'Manual Upload (Admin CSV upload)',
    value: CensusIngestionChannel.MANUAL_UPLOAD,
  },
]

interface ChannelMultiSelectProps {
  value: CensusIngestionChannel[]
  disabled: boolean
  onChange: (channels: CensusIngestionChannel[]) => void
}

export default function ChannelMultiSelect({
  value,
  disabled,
  onChange,
}: ChannelMultiSelectProps) {
  return (
    <div className={styles.fieldGroup}>
      <label className={styles.label}>Ingestion Channels</label>
      <p className={styles.panelSubtitle} style={{ margin: 0 }}>
        This rule only suppresses incoming changes to the selected fields for
        the channels checked below — other channels are unaffected.
      </p>
      <Checkbox.Group
        options={CHANNEL_OPTIONS}
        value={value}
        disabled={disabled}
        onChange={(checked) => onChange(checked as CensusIngestionChannel[])}
      />
    </div>
  )
}
